<template>
  <!--==================
    component shows all packages rearrangement (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="card">
      <input
        class="form-control mb-4"
        placeholder="Search by id"
        v-model="keyword"
        type="number"
        style="max-width: 300px"
      />
      <div class="table-responsive">
        <table id="table-package" class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>POSITION</th>
              <th>TOUR ID</th>
              <th>TOUR TITLE</th>
              <th>OPERATOR</th>
              <th>TOUR PRICE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filteredPackageById.length" class="text-center">
              <td colspan="4">
                <span class="text-muted"><em>Data not found for this operator</em></span>
              </td>
            </tr>
            <tr v-for="tour in filteredPackageById" :key="tour.id" :data-position="tour.position" :data-id="tour.id">
              <td :id="'row-' + tour.id" style="max-width: 120px">
                <input
                  type="text"
                  class="form-control"
                  :value="tour.position"
                  @change="updatePosition(tour.id, tour.position, $event)"
                  style="width: 70px"
                />
              </td>
              <td class="text-left">{{ tour.id }}</td>
              <td class="font-weight-bold" style="max-width: 400px; overflow: hidden">
                <a class="d-block p-3" :href="packageUrl + tour.id" target="_blank">{{
                  tour.noOfDay + "-Day " + tour.title
                }}</a>
              </td>
              <td class="text-left" style="">
                <img :src="tour.operator.logo" width="50" />
                {{ tour.operator.companyName }}
              </td>
              <td class="text-left">{{ tour.price | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OperatorPackage",

  data() {
    return {
      management: false,
      filteredPackageById: [],
      keyword: "",
    };
  },

  watch: {
    keyword: function () {
      if (this.keyword && this.allRearrangePackages != undefined) {
        this.filteredPackageById = this.allRearrangePackages.filter((item) => {
          return item.id == this.keyword;
        });
      } else {
        this.filteredPackageById = this.allRearrangePackages;
      }
    },
  },

  computed: {
    ...mapGetters(["allRearrangePackages"]),

    packageUrl() {
      return process.env.VUE_APP_PACKAGE_URL;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchPublishedOperatorPackages("all");
      this.hideBarLoading();
      this.filteredPackageById = this.allRearrangePackages;
    });
  },

  methods: {
    ...mapActions(["fetchPublishedOperatorPackages", "hideBarLoading", "hideSpinnerLoading", "updatePackagePosition"]),

    async updatePosition(id, position, e) {
      const oldPosition = position;
      const newPosition = parseInt(e.target.value);
      const packages = this.allRearrangePackages;

      var positions = [
        {
          id: id,
          position: newPosition,
        },
      ];

      if (newPosition > 0 && newPosition <= packages.length) {
        if (oldPosition < newPosition) {
          for (let i = oldPosition; i < newPosition; i++) {
            const packagePosition = {
              id: packages[i].id,
              position: packages[i].position - 1,
            };

            positions.push(packagePosition);
          }
        } else {
          for (let i = oldPosition - 2; i >= newPosition - 1; i--) {
            const packagePosition = {
              id: packages[i].id,
              position: packages[i].position + 1,
            };

            positions.push(packagePosition);
          }
        }
      }

      // console.log(positions);

      await this.updatePackagePosition(positions);

      if (this.keyword) {
        await this.fetchPublishedOperatorPackages("all");
        this.keyword = "";
      } else {
        await this.fetchPublishedOperatorPackages("all");
        this.filteredPackageById = this.allRearrangePackages;
      }

      this.hideSpinnerLoading();
    },
  },
};
</script>
